<template>
  <v-toolbar v-if="badge" id="core-toolbar" flat prominent>
   
       <Footer v-if="$route.name !== 'Maps'" />
    <div class="v-toolbar-title ml-3">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>


    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
       
        <!--<button v-ripple-->
        <!--@click="toggle"-->
        <!--class="toolbar-items">-->
        <!--<v-icon v-if="!fullscreen" color="tertiary">mdi-fullscreen</v-icon>-->
        <!--<v-icon v-else color="tertiary">mdi-fullscreen-exit</v-icon>-->
        <!--</button>-->

        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
         
          <div v-ripple slot="activator" class="toolbar-items">
            <v-badge color="error" overlap>
              <template slot="badge" v-if="countBadges">{{ countBadges }}</template>
              <v-icon color="tertiary">mdi-bell</v-icon>
            </v-badge>
          </div>

          <v-card v-if="countBadges">
            <v-list dense>
              <v-list-tile v-for="notification in notifications" :key="notification">
                <router-link v-ripple class="toolbar-items" :to="notification.link">
                  <v-list-tile-title v-text="notification.text" />
                </router-link>
              </v-list-tile>
            </v-list>
          </v-card>

        </v-menu>
        
        <div v-ripple class="toolbar-items" @click="logout">
          <v-icon color="tertiary">mdi-logout</v-icon>
        </div>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import Footer from "./Footer";

export default {
  props: ["logout", "toggle", "fullscreen"],
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    }
  },
  components:{Footer},
  computed: {
    ...mapState(["badge"]),
    notifications: {
      get() {
        let notify = [];
        if (this.badge.messages)
          notify.push({
            text: this.badge.messages + " новых сообщений",
            link: "feedback"
          });
        if (this.badge.activations)
          notify.push({
            text: this.badge.activations + " новых активаций",
            link: "activations"
          });

        if (this.badge.orders_distributors)
          notify.push({
            text: this.badge.orders_distributors + " новых закаов (дистрибьюция)",
            link: "distributions?tab=1"
          });

        if (this.badge.orders)
          notify.push({
            text: this.badge.orders + " новых заказа-(ов)",
            link: "orders"
          });

        return notify;
      }
    },
    countBadges: {
      get() {
        // console.log(this.badge);
        return (
          this.badge.messages +
          this.badge.activations +
          this.badge.orders +
          this.badge.orders_distributors
        );
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.title = this.$route.name;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    }
  }
};
</script>

<style>
#core-toolbar {
  z-index: 2;
  position: sticky !important;
  top: 0 !important;
  overflow: hidden;
}

#core-toolbar a {
  text-decoration: none;
}
</style>
